import React, { useState } from 'react';
import './style.scss';

function ShareButton() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  // const togglePopup = () => {
  //   setIsPopupOpen(!isPopupOpen);
  // };

  const closePopup = () => {
    setIsPopupOpen(false);
  };

  const copyLink = () => {
    navigator.clipboard.writeText('https://vizion.global/');
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Escape') {
      closePopup();
    }
  };

  const handleDialogClick = (e) => {
    // Close dialog when clicking on backdrop (dialog element itself)
    if (e.target === e.currentTarget) {
      closePopup();
    }
  };

  return (
    <>
      <div
        type="button"
        className="share-button"
        // onClick={togglePopup}
        aria-label="Share"
      >
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            d="M11.0001 1.5C9.80353 1.5 8.83348 2.47005 8.83348 3.66667C8.83348 3.79727 8.84503 3.92518 8.86718 4.04942L5.71341 6.25705C5.69739 6.26827 5.68222 6.28026 5.66793 6.29293C5.30009 6.00498 4.83683 5.83333 4.33348 5.83333C3.13686 5.83333 2.16681 6.80338 2.16681 8C2.16681 9.19662 3.13686 10.1667 4.33348 10.1667C4.83683 10.1667 5.30009 9.99502 5.66793 9.70707C5.68222 9.71974 5.69739 9.73173 5.71341 9.74295L8.86718 11.9506C8.84503 12.0748 8.83348 12.2027 8.83348 12.3333C8.83348 13.53 9.80353 14.5 11.0001 14.5C12.1968 14.5 13.1668 13.53 13.1668 12.3333C13.1668 11.1367 12.1968 10.1667 11.0001 10.1667C10.2983 10.1667 9.67437 10.5004 9.27843 11.0178L6.29218 8.92743C6.42554 8.64628 6.50014 8.33185 6.50014 8C6.50014 7.66815 6.42554 7.35372 6.29218 7.07257L9.27843 4.9822C9.67437 5.49961 10.2983 5.83333 11.0001 5.83333C12.1968 5.83333 13.1668 4.86328 13.1668 3.66667C13.1668 2.47005 12.1968 1.5 11.0001 1.5ZM9.83348 3.66667C9.83348 3.02233 10.3558 2.5 11.0001 2.5C11.6445 2.5 12.1668 3.02233 12.1668 3.66667C12.1668 4.311 11.6445 4.83333 11.0001 4.83333C10.3558 4.83333 9.83348 4.311 9.83348 3.66667ZM4.33348 6.83333C3.68914 6.83333 3.16681 7.35567 3.16681 8C3.16681 8.64433 3.68914 9.16667 4.33348 9.16667C4.97781 9.16667 5.50014 8.64433 5.50014 8C5.50014 7.35567 4.97781 6.83333 4.33348 6.83333ZM11.0001 11.1667C10.3558 11.1667 9.83348 11.689 9.83348 12.3333C9.83348 12.9777 10.3558 13.5 11.0001 13.5C11.6445 13.5 12.1668 12.9777 12.1668 12.3333C12.1668 11.689 11.6445 11.1667 11.0001 11.1667Z"
            fill="white"
          />
        </svg>
      </div>

      {/* Popup */}
      {isPopupOpen && (
        /* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */
        // NOSONAR javascript:S6847 - dialog needs onClick/onKeyDown for backdrop interaction
        <dialog
          className="popup-overlay"
          onClick={handleDialogClick}
          onKeyDown={handleKeyDown}
          aria-modal="true"
          aria-labelledby="share-title"
          open
        >
          <div className="popup-content">
            <button className="close-button" onClick={closePopup}>
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15 5L5 15M5 5L15 15"
                  stroke="#090A0B"
                  strokeWidth="1.6"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
              </svg>
            </button>
            <div className="popup-body">
              <h3 id="share-title">Share</h3>
              <div className="share-options">
                <div className="share-facebook">
                  <svg
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="16" cy="16" r="14" fill="#090A0B"></circle>
                    <path
                      d="M21.2137 20.2816L21.8356 16.3301H17.9452V13.767C17.9452 12.6857 18.4877 11.6311 20.2302 11.6311H22V8.26699C22 8.26699 20.3945 8 18.8603 8C15.6548 8 13.5617 9.89294 13.5617 13.3184V16.3301H10V20.2816H13.5617V29.8345C14.2767 29.944 15.0082 30 15.7534 30C16.4986 30 17.2302 29.944 17.9452 29.8345V20.2816H21.2137Z"
                      fill="white"
                    ></path>
                  </svg>
                  <p>Facebook</p>
                </div>
                <div className="share-twitter">
                  <svg
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11.7887 28C8.55374 28 5.53817 27.0591 3 25.4356C5.15499 25.5751 8.95807 25.2411 11.3236 22.9848C7.76508 22.8215 6.16026 20.0923 5.95094 18.926C6.25329 19.0426 7.6953 19.1826 8.50934 18.856C4.4159 17.8296 3.78793 14.2373 3.92748 13.141C4.695 13.6775 5.99745 13.8641 6.50913 13.8174C2.69479 11.0882 4.06703 6.98276 4.74151 6.09635C7.47882 9.88867 11.5812 12.0186 16.6564 12.137C16.5607 11.7174 16.5102 11.2804 16.5102 10.8316C16.5102 7.61092 19.1134 5 22.3247 5C24.0025 5 25.5144 5.71275 26.5757 6.85284C27.6969 6.59011 29.3843 5.97507 30.2092 5.4432C29.7934 6.93611 28.4989 8.18149 27.7159 8.64308C27.7095 8.62731 27.7224 8.65878 27.7159 8.64308C28.4037 8.53904 30.2648 8.18137 31 7.68256C30.6364 8.52125 29.264 9.91573 28.1377 10.6964C28.3473 19.9381 21.2765 28 11.7887 28Z"
                      fill="#090A0B"
                    ></path>
                  </svg>
                  <p>Twitter</p>
                </div>
              </div>
              <h2 className="page-link">Page link</h2>
              <div className="copy-link">
                <span>https://vizion.global/</span>
                <button onClick={copyLink}>
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M15 1.25H10.9436C9.10583 1.24998 7.65019 1.24997 6.51098 1.40314C5.33856 1.56076 4.38961 1.89288 3.64124 2.64124C2.89288 3.38961 2.56076 4.33856 2.40314 5.51098C2.24997 6.65019 2.24998 8.10582 2.25 9.94357V16C2.25 17.8722 3.62205 19.424 5.41551 19.7047C5.55348 20.4687 5.81753 21.1208 6.34835 21.6517C6.95027 22.2536 7.70814 22.5125 8.60825 22.6335C9.47522 22.75 10.5775 22.75 11.9451 22.75H15.0549C16.4225 22.75 17.5248 22.75 18.3918 22.6335C19.2919 22.5125 20.0497 22.2536 20.6517 21.6517C21.2536 21.0497 21.5125 20.2919 21.6335 19.3918C21.75 18.5248 21.75 17.4225 21.75 16.0549V10.9451C21.75 9.57754 21.75 8.47522 21.6335 7.60825C21.5125 6.70814 21.2536 5.95027 20.6517 5.34835C20.1208 4.81753 19.4687 4.55348 18.7047 4.41551C18.424 2.62205 16.8722 1.25 15 1.25ZM17.1293 4.27117C16.8265 3.38623 15.9876 2.75 15 2.75H11C9.09318 2.75 7.73851 2.75159 6.71085 2.88976C5.70476 3.02502 5.12511 3.27869 4.7019 3.7019C4.27869 4.12511 4.02502 4.70476 3.88976 5.71085C3.75159 6.73851 3.75 8.09318 3.75 10V16C3.75 16.9876 4.38624 17.8265 5.27117 18.1293C5.24998 17.5194 5.24999 16.8297 5.25 16.0549V10.9451C5.24998 9.57754 5.24996 8.47522 5.36652 7.60825C5.48754 6.70814 5.74643 5.95027 6.34835 5.34835C6.95027 4.74643 7.70814 4.48754 8.60825 4.36652C9.47522 4.24996 10.5775 4.24998 11.9451 4.25H15.0549C15.8297 4.24999 16.5194 4.24998 17.1293 4.27117ZM7.40901 6.40901C7.68577 6.13225 8.07435 5.9518 8.80812 5.85315C9.56347 5.75159 10.5646 5.75 12 5.75H15C16.4354 5.75 17.4365 5.75159 18.1919 5.85315C18.9257 5.9518 19.3142 6.13225 19.591 6.40901C19.8678 6.68577 20.0482 7.07435 20.1469 7.80812C20.2484 8.56347 20.25 9.56458 20.25 11V16C20.25 17.4354 20.2484 18.4365 20.1469 19.1919C20.0482 19.9257 19.8678 20.3142 19.591 20.591C19.3142 20.8678 18.9257 21.0482 18.1919 21.1469C17.4365 21.2484 16.4354 21.25 15 21.25H12C10.5646 21.25 9.56347 21.2484 8.80812 21.1469C8.07435 21.0482 7.68577 20.8678 7.40901 20.591C7.13225 20.3142 6.9518 19.9257 6.85315 19.1919C6.75159 18.4365 6.75 17.4354 6.75 16V11C6.75 9.56458 6.75159 8.56347 6.85315 7.80812C6.9518 7.07435 7.13225 6.68577 7.40901 6.40901Z"
                      fill="#090A0B"
                    ></path>
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </dialog>
      )}
    </>
  );
}

export default ShareButton;
